// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1Eooo","label":"Radio_label__1aC-m","checkMark":"Radio_checkMark__1-xWc","disabled":"Radio_disabled__22oGS"};